<template>
  <nav
    class="fixed start-0 end-0 top-0 z-50 h-[70px] transition-[background,backdrop-filter] duration-200 desktop:h-[88px]"
    :class="isScrolled ? 'border-b border-black/[0.06] bg-white/85 backdrop-blur-md' : 'bg-transparent'"
  >
    <div class="container flex h-full items-center justify-between">
      <UILogo
        :link="false"
        :size="28"
        class="cursor-pointer transition-opacity hover:opacity-80"
        :aria-label="t('landing.header.homeAriaLabel')"
        @click="scrollToTop"
      />
      <div class="flex items-center gap-1.5 sm:gap-2">
        <LocaleMenu v-if="page !== '/uae'" />
        <NuxtLink
          :to="loginHref"
          class="px-3 py-2 text-sm font-medium text-black-80 transition-colors hover:text-black-100"
        >
          {{ t('landing.header.login') }}
        </NuxtLink>
        <NuxtLink
          :to="signupHref"
          class="hidden h-10 items-center justify-center gap-2 rounded-[10px] bg-gradient-to-b from-gold-primary-100 to-gold-primary-120 px-4 text-[13px] font-bold text-black-100 shadow-[0_8px_20px_rgba(237,164,54,0.25)] transition-transform hover:-translate-y-px tablet:inline-flex"
          @click="trackCtaClick('header')"
        >
          {{ t('landing.header.getAccess') }}
        </NuxtLink>
      </div>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { useWindowScroll } from '@vueuse/core';

const { t } = useI18n();

defineProps<{ variant?: 'black' | 'white' }>();

const { y } = useWindowScroll();
const isScrolled = computed(() => y.value > 10);

const { page } = useLandingPage();
const { signupHref } = useSignupHref();
const { trackCtaClick } = useLandingTracking();
const loginHref = computed(() => '/auth/login');

const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
</script>
